import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/layout/Logo";
import { RegisterFlow } from "@/components/auth/RegisterFlow";
import { CheckCircle2 } from "lucide-react";

export default function Register() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stage, setStage] = useState("email");

  if (user) return <Navigate to="/dashboard" replace />;

  const wide = stage === "typeform" || stage === "fetching";

  return (
    <div className={`min-h-screen ${wide ? "flex flex-col" : "grid lg:grid-cols-2"}`}>
      {!wide && (
        <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12 relative overflow-hidden">
          <img src="https://images.unsplash.com/photo-1562774053-701939374585?w=1200&q=80" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-br from-navy-deep to-navy/60" />
          <div className="relative"><Logo light /></div>
          <div className="relative">
            <h2 className="headline text-5xl">Start your <span className="text-orange">elite</span> journey</h2>
            <ul className="mt-6 space-y-3 text-white/80">
              {["Verified account in a few quick steps", "2 AI advisors tailored to your level", "CV, cover letter, predictor & orientation"].map((t) => (
                <li key={t} className="flex items-center gap-2"><CheckCircle2 className="h-5 w-5 text-orange" /> {t}</li>
              ))}
            </ul>
          </div>
          <div className="relative text-white/40 text-xs">© 2026 Elite by Thotis Media</div>
        </div>
      )}

      <div className={`flex-1 flex ${wide ? "items-start" : "items-center"} justify-center p-6 sm:p-12 bg-background overflow-y-auto`}>
        <div className={`w-full ${wide ? "max-w-4xl" : "max-w-md"}`}>
          <div className="lg:hidden mb-8"><Logo /></div>
          <RegisterFlow onSuccess={() => navigate("/dashboard")} onStageChange={setStage} />
        </div>
      </div>
    </div>
  );
}
